import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import { ApplicationStatusMessageType } from 'src/types/applicationStatusMessage';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Select from 'src/components/Select';
import { langCodes } from 'src/resources/constantsCodes/constants';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './index';
import { applicationMessageColorOptionFce } from '../../utils/colorOptionFce';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ApplicationStatusMessageType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    applicationMessageCodes: ConstantsCodeType[];
    applicationMessageNotificationTypesCodes: ConstantsCodeType[];
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.TITLE}
                    error={props.editErrors.TITLE}
                    onChange={(value, error) => props.onChange('TITLE', value, error)}
                    name="TITLE"
                    label={translate('applicationStatusMessageDetail.titleEdit')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                    multiline
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.TEXT}
                    error={props.editErrors.TEXT}
                    onChange={(value, error) => props.onChange('TEXT', value, error)}
                    name="TEXT"
                    label={translate('applicationStatusMessageDetail.text')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                    multiline
                />
            </GridItem>
            <GridItem cols={4}>
                <Select
                    options={props.applicationMessageCodes}
                    value={props.editData.TYPE}
                    error={props.editErrors.TYPE}
                    onChange={(value, error) => props.onChange('TYPE', value, error)}
                    name="TYPE"
                    label={translate('applicationStatusMessageDetail.type')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                    optionStyleFce={applicationMessageColorOptionFce}
                />
            </GridItem>
            <GridItem cols={4}>
                <Select
                    options={props.applicationMessageNotificationTypesCodes}
                    value={props.editData.NOTIFICATION_TYPE}
                    error={props.editErrors.NOTIFICATION_TYPE}
                    onChange={(value, error) => props.onChange('NOTIFICATION_TYPE', value, error)}
                    name="NOTIFICATION_TYPE"
                    label={translate('applicationStatusMessageDetail.notificationType')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={4}>
                <Select
                    options={langCodes}
                    value={props.editData.LANG}
                    error={props.editErrors.LANG}
                    onChange={(value, error) => props.onChange('LANG', value, error)}
                    name="LANG"
                    label={translate('applicationStatusMessageDetail.lang')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
